import { useEffect } from 'react';
import { useRemoteParticipants, useRoomContext } from '@livekit/components-react';
import type { Room } from 'livekit-client';

/** Render inside <LiveKitRoom>: reports the Room and the first remote participant. */
export function LiveKitConnectionWatcher({
  onRoom,
  onRemoteJoined,
}: {
  onRoom: (room: Room) => void;
  onRemoteJoined: () => void;
}) {
  const room = useRoomContext();
  const remoteParticipants = useRemoteParticipants();

  useEffect(() => {
    onRoom(room);
  }, [room, onRoom]);

  useEffect(() => {
    if (remoteParticipants.length > 0) onRemoteJoined();
  }, [remoteParticipants.length, onRemoteJoined]);

  return null;
}
